import { useState } from "react";
import { useRecoilValue } from "recoil";
import Loc from "../../../Loc/Loc";
import { userAtom } from "../../RecoilApp";
import "./SendDocs.css"

export default function HeaderSendDocs() {
    const user = useRecoilValue(userAtom);
    const [infoExpand, setInfoExpand] = useState(false);
    const HandleExpandOnClick = () => {
        setInfoExpand(!infoExpand);
    }

    return (
        <div>
            <div className="Sender">{Loc.trad().HeaderSendDocsSender}{user.recipient}</div>
            <div className="Informations">
                {
                    infoExpand ?
                        <div>
                            <button className="btn btn-light btn-sm expandButton" onClick={HandleExpandOnClick}>-</button>
                            <span style={{ fontWeight: "bold" }}>{Loc.trad().HeaderSendDocsInfo}</span><br />
                            <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Tenetur repudiandae dolores ea explicabo totam ipsum,
                                nam sapiente animi voluptatem consequatur est quis dolor doloremque debitis nemo optio dicta provident earum.
                                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Fuga mollitia, amet veniam perspiciatis at,
                                esse consectetur impedit totam soluta numquam obcaecati saepe quam reprehenderit officiis. Blanditiis pariatur excepturi et odio?
                            </div>
                        </div> :
                        <div>
                            <button className="btn btn-light btn-sm expandButton" onClick={HandleExpandOnClick}>+</button>
                            <span style={{ fontWeight: "bold" }}>{Loc.trad().HeaderSendDocsInfo}</span>
                        </div>
                }
            </div>
        </div>
    )
}